/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespBreadcrumbs_item = {
    readonly breadcrumbs: ReadonlyArray<{
        readonly key: string | null;
        readonly path: string | null;
        readonly displayName: string | null;
    } | null> | null;
    readonly " $refType": "PdpRespBreadcrumbs_item";
};
export type PdpRespBreadcrumbs_item$data = PdpRespBreadcrumbs_item;
export type PdpRespBreadcrumbs_item$key = {
    readonly " $data"?: PdpRespBreadcrumbs_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespBreadcrumbs_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespBreadcrumbs_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "breadcrumbs",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemBreadcrumb",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "key",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "path",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'c5fe69e64671b268ee9fb155ac9eedac';
export default node;
